export var TagDomAttribute;
(function (TagDomAttribute) {
    TagDomAttribute["SMART_TAG_PARENT"] = "smart-tag-parent";
    TagDomAttribute["SMART_TAG"] = "smart-tag";
    TagDomAttribute["CONTENT"] = "smart-tag-content";
    TagDomAttribute["OVERLAY"] = "smart-tag-overlay";
    TagDomAttribute["LOADING_ANIMATION"] = "smart-tag-loading-animation";
})(TagDomAttribute || (TagDomAttribute = {}));
